import { ChevronRight, Handshake } from 'lucide-react';

// How the partner button renders on a public proptree. Mirrors
// PartnerButton in apps/landing/app/[slug]/ProptreeBody.tsx — keep the
// two in step so the admin preview matches the real page.

/** Dark text on light brand colours, white otherwise. */
export function partnerTextColor(hex: string): '#ffffff' | '#111827' {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return '#ffffff';
  const n = parseInt(m[1]!, 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.45 ? '#111827' : '#ffffff';
}

export function PartnerButtonPreview({
  name,
  subtitle,
  color,
  logo,
  ctaLabel,
}: {
  name: string;
  subtitle: string | null;
  color: string;
  logo: string | null;
  ctaLabel: string;
}) {
  const text = partnerTextColor(color);
  return (
    <div
      className="flex w-full items-center gap-4 rounded-2xl p-4"
      style={{ backgroundColor: color, color: text }}
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white">
        {logo ? (
          <img src={logo} alt="" className="h-6 w-6 object-contain" />
        ) : (
          <Handshake className="h-5 w-5" style={{ color }} />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-bold">{name || 'Partner name'}</div>
        {subtitle && (
          <div className="truncate text-sm font-medium opacity-80">{subtitle}</div>
        )}
      </div>
      <span
        className="inline-flex shrink-0 items-center gap-1 rounded-full bg-white px-3.5 py-1.5 text-xs font-bold"
        style={{ color }}
      >
        {ctaLabel || 'More info'}
        <ChevronRight className="h-3 w-3" strokeWidth={2.5} />
      </span>
    </div>
  );
}
